export enum RoleId {
  AGENT = 1,
  USER = 2,
  SYSTEM_ADMIN = 3,
  AVL_INTERFACE = 4,
  ON_BEHALF_OF = 5,
  TITLE_ESCROW_USER = 7,
  TITLE_ONLY_USER = 10,
  ESCROW_ONLY_USER = 11,
  CPL_ONLY = 12,
  STAFF_ADMIN = 13,
  FSC_ORDER_MANAGEMENT = 14,
  APPROVED_ATTORNEY = 15,
}
